import APP from '../app/index';
import Util from '../helpers/index';

$(() => {
  const navText = ['меню', 'закрыть'];
  const $navBtn = $('.js-nav-btn');
  const $navBtnFloat = $('.js-nav-float-btn');
  const $navContainer = $('.js-nav-container');
  const $headerContainer = $('.header');
  let headerY = $headerContainer.outerHeight() + ($headerContainer.position()).top;
  let scrollY = 0;

  const addPaddingScrollWidth = () => {
    const heightViewport = APP.$body.height() + APP.$footer.height();

    if (heightViewport > APP.$window.height()) {
      const scrollBarWidth = Util.getScrollBarWidth();

      APP.$footer.css('padding-right', `${scrollBarWidth}px`);
      APP.$header.css('padding-right', `${scrollBarWidth}px`);
      APP.$body.css('padding-right', `${scrollBarWidth}px`);
    }
  };
  const removePaddingScrollWidth = () => {
    APP.$footer.css('padding-right', 0);
    APP.$header.css('padding-right', 0);
    APP.$body.css('padding-right', 0);
  };

  const openNav = () => {
    APP.$body.addClass('nav-open');
    $navBtn.addClass('is-open');
    $navContainer.fadeIn();
    $navBtn.find('span').text(navText[1]);
    $navBtnFloat.fadeOut(50);

    addPaddingScrollWidth();
  };

  const closeNav = () => {
    $navBtn.removeClass('is-open');
    $navBtn.find('span').text(navText[0]);

    $navContainer.fadeOut(() => {
      APP.$body.removeClass('nav-open');
      removePaddingScrollWidth();

      if (scrollY > headerY) {
        $navBtnFloat.fadeIn();
      }
    });
  };
  // click handler for btn menu in header
  $navBtn.click(() => {
    if ($navBtn.hasClass('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });
  // click hanlder for btn burger
  $navBtnFloat.click(() => {
    openNav();
  });

  $(window).scroll(() => {
    scrollY = window.pageYOffset;

    if (!headerY) {
      headerY = $headerContainer.outerHeight() + ($headerContainer.position()).top;
    }

    if (!APP.$body) {
      return; // TODO: find best practices
    }

    if (scrollY > headerY && !APP.$body.hasClass('nav-open')) {
      $navBtnFloat.fadeIn();
    } else {
      $navBtnFloat.fadeOut(100);
    }
  });

  $(window).resize(() => {
    if (headerY) {
      headerY = null;
    }
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/nav/index.js